import { render, staticRenderFns } from "./PostcodecheckerV3.vue?vue&type=template&id=6bb4e7cd&scoped=true"
import script from "./PostcodecheckerV3.vue?vue&type=script&lang=js"
export * from "./PostcodecheckerV3.vue?vue&type=script&lang=js"
import style0 from "./PostcodecheckerV3.vue?vue&type=style&index=0&id=6bb4e7cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4e7cd",
  null
  
)

export default component.exports